module.exports = __webpack_public_path__ + "static/digitalNotification4-41253b74b282bc48c3cd3f691e811fb0.png";